var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: { disabled: _vm.isDisabled } }, [
    _c("input", {
      attrs: { type: "checkbox", id: _vm.name, disabled: _vm.isDisabled },
      domProps: { value: _vm.value },
      on: { change: _vm.handleChange },
    }),
    _vm._v(" "),
    _c(
      "label",
      { attrs: { for: _vm.name } },
      [
        !_vm.value ? _c("checkbox-empty") : _vm._e(),
        _vm._v(" "),
        _vm.value ? _c("checkbox-selected") : _vm._e(),
        _vm._v(" "),
        _c("span", {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.label,
              expression: "label",
            },
          ],
          domProps: { innerHTML: _vm._s(_vm.label) },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _vm.error
      ? _c("span", { staticClass: "error" }, [_vm._v(_vm._s(_vm.error))])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }